import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-booking-service-card',
  standalone: false,
  templateUrl: './booking-service-card.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./booking-service-card.component.scss'],
})
export class BookingServiceCardComponent {
  imageUrl = input<string>();
  title = input<string>();
  description = input<string>();
  badgeText = input<string>();
  initials = input<string>();
  disabled = input(false);

  cardClick = output<void>();

  onCardClick(): void {
    if (!this.disabled()) {
      this.cardClick.emit();
    }
  }
}
